import {adminAxios} from '../../config/axiosConfig/InstancesAxios'

export default {

  login: (model)=>{
    return adminAxios.post("/admin/login", model)
  }
}